/**
 * POS Menus Service
 *
 * API calls for POS menus management.
 * @see Sprint 25a - Gestion des Promotions
 */

import { apiClient } from '@/api/client';
import type {
  PosMenu,
  PosMenuListResponse,
  PosMenuUpdateInput,
  PosMenuQueryParams,
  PosMenuSyncResponse,
  ApiSuccess,
} from '@bstock/shared';

// Re-export types for convenience
export type { PosMenu, PosMenuUpdateInput, PosMenuQueryParams, PosMenuSyncResponse };

export const posMenusService = {
  /**
   * List all menus
   */
  async list(params?: PosMenuQueryParams): Promise<PosMenuListResponse> {
    const searchParams = new URLSearchParams();
    if (params?.search) searchParams.set('search', params.search);
    if (params?.isPromo !== undefined) searchParams.set('isPromo', String(params.isPromo));
    if (params?.isActive !== undefined) searchParams.set('isActive', String(params.isActive));

    const query = searchParams.toString();
    const url = `/pos/menus${query ? `?${query}` : ''}`;

    const response = await apiClient.get<ApiSuccess<PosMenuListResponse>>(url);
    return response.data.data;
  },

  /**
   * Get menu by ID
   */
  async getById(id: string): Promise<PosMenu> {
    const response = await apiClient.get<ApiSuccess<PosMenu>>(`/pos/menus/${id}`);
    return response.data.data;
  },

  /**
   * Update menu (isPromo flag)
   */
  async update(id: string, input: PosMenuUpdateInput): Promise<PosMenu> {
    const response = await apiClient.patch<ApiSuccess<PosMenu>>(`/pos/menus/${id}`, input);
    return response.data.data;
  },

  /**
   * Sync menus from Bill API
   */
  async sync(): Promise<PosMenuSyncResponse> {
    const response = await apiClient.post<ApiSuccess<PosMenuSyncResponse>>('/pos/menus/sync');
    return response.data.data;
  },
};
